var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_62_2",
    "data-name": "Component 62 \\u2013 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13",
    "data-name": "Rectangle 13",
    width: 32,
    height: 32,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "delete-svgrepo-com",
    transform: "translate(5 5.052)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    width: 2,
    height: 9,
    transform: "translate(8 7.948)",
    fill: "#757981"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11",
    "data-name": "Rectangle 11",
    width: 2,
    height: 9,
    transform: "translate(12 7.948)",
    fill: "#757981"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_551",
    "data-name": "Path 551",
    d: "M4,6V7.372H5.372V21.089a1.372,1.372,0,0,0,1.372,1.372H17.718a1.372,1.372,0,0,0,1.372-1.372V7.372h1.372V6ZM6.744,21.089V7.372H17.718V21.089Z",
    transform: "translate(-1.256 -1.885)",
    fill: "#757981"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    width: 6,
    height: 2,
    transform: "translate(8 0.948)",
    fill: "#757981"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_Transparent_Rectangle_",
    "data-name": "<Transparent Rectangle>",
    width: 22,
    height: 22,
    transform: "translate(0 -0.052)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.2cf1e3340600a2680110a4a01c9314bc.svg";
export { ForwardRef as ReactComponent };